import Factory from "../Factory";
import { FactoryInterface } from "../FactoryInterface";
import { Message } from "../Entities/Message/Message";
import { MessageInterface } from "../Entities/Message/MessageInterface";

class MessageFactory extends Factory implements FactoryInterface {
  public create(data: any): MessageInterface {
    return new Message({
      id: data.id,
      agencyId: data.agencyId,
      createdAt: data.createdAt ? new Date(data.createdAt) : null,
      createdBy: data.createdBy,
      updatedAt: data.updatedAt ? new Date(data.updatedAt) : null,
      updatedBy: data.updatedBy,
      removed: data.removed,
      statusId: data.statusId,
      conversationId: data.conversationId,
      senderId: data.senderId,
      message: data.message,
      notificationChannels: data.notificationChannels || [],
      senderDisplayName: data.senderDisplayName
    });
  };

  public reinitialize(data: any): MessageInterface {
    return new Message({
      ...data
    });
  }
}

export default new MessageFactory();
